// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ykJz0{display:flex;align-items:center;justify-content:space-between}.szklz{display:flex;justify-content:flex-end;width:100%}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"invoiceIdCell": `ykJz0`,
	"paginationControls": `szklz`
};
export default ___CSS_LOADER_EXPORT___;
